import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllAgents } from "../../api/apiAgents";
import parseError from "../../utils/parseError";

const useRestoreAllAgents = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAllAgentsAction, isPending } = useMutation({
        mutationFn: restoreAllAgents,
        onSuccess: (res) => {
            const message = res?.message || "Agents restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["agents"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore agents");
        },
    });

    return { restoreAllAgents: restoreAllAgentsAction, isPending };
};

export default useRestoreAllAgents;
